/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MedicaidCaseList } from './MedicaidCaseList';
import {
    MedicaidCaseListFromJSON,
    MedicaidCaseListFromJSONTyped,
    MedicaidCaseListToJSON,
    MedicaidCaseListToJSONTyped,
} from './MedicaidCaseList';

/**
 * 
 * @export
 * @interface MedicaidCaseListResponse
 */
export interface MedicaidCaseListResponse {
    /**
     * 
     */
    data: MedicaidCaseList;
}

/**
 * Check if a given object implements the MedicaidCaseListResponse interface.
 */
export function instanceOfMedicaidCaseListResponse(value: object): value is MedicaidCaseListResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function MedicaidCaseListResponseFromJSON(json: any): MedicaidCaseListResponse {
    return MedicaidCaseListResponseFromJSONTyped(json, false);
}

export function MedicaidCaseListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicaidCaseListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': MedicaidCaseListFromJSON(json['data']),
    };
}

export function MedicaidCaseListResponseToJSON(json: any): MedicaidCaseListResponse {
    return MedicaidCaseListResponseToJSONTyped(json, false);
}

export function MedicaidCaseListResponseToJSONTyped(value?: MedicaidCaseListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': MedicaidCaseListToJSON(value['data']),
    };
}

